import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { buildPdfDocumentMarkup } from "./exportPdfLayout";

const PAGE_SELECTOR = ".pdf-page";

const createCaptureRoot = (markup) => {
  const root = document.createElement("div");
  root.style.position = "fixed";
  root.style.top = "0";
  root.style.left = "-100000px";
  root.style.zIndex = "-1";
  root.style.background = "#edf2f7";
  root.innerHTML = markup;
  document.body.appendChild(root);
  return root;
};

const waitForLayoutStability = async () => {
  if (document.fonts?.ready) {
    await document.fonts.ready;
  }

  await new Promise((resolve) => window.requestAnimationFrame(resolve));
};

const renderPageToCanvas = async (element) =>
  html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
    logging: false,
  });

const addCanvasPage = ({ canvas, pdf, isFirstPage }) => {
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 8;
  const width = pageWidth - margin * 2;
  const height = (canvas.height * width) / canvas.width;

  if (!isFirstPage) {
    pdf.addPage();
  }

  pdf.addImage(canvas.toDataURL("image/png"), "PNG", margin, margin, width, Math.min(height, pageHeight - margin * 2));
};

export const exportReportToPdf = async ({ filename, model, t }) => {
  const root = createCaptureRoot(buildPdfDocumentMarkup({ model, t }));

  try {
    await waitForLayoutStability();
    const pages = Array.from(root.querySelectorAll(PAGE_SELECTOR));
    const pdf = new jsPDF("p", "mm", "a4");

    for (let index = 0; index < pages.length; index += 1) {
      const canvas = await renderPageToCanvas(pages[index]);
      addCanvasPage({ canvas, pdf, isFirstPage: index === 0 });
    }

    pdf.save(filename);
  } finally {
    document.body.removeChild(root);
  }
};
